module.exports = __webpack_public_path__ + "img/aec1716.jpg";